<div class="secure-key-administration">

  <sc-master-detail [selection]="[selectedSecureKey]" [data]="secureKeys" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <form class="form" [formGroup]="formGroup">
        <sc-padding>
          <sc-flex vertical stretchContent *ngIf="secureKeyDetails" class="no-field-space">
            <sc-read-only-field labelDictionaryKey="tmc-yard.secure-key.entity.consecutive-number"
              [value]="secureKeyDetails.consecutiveNumber != null ? secureKeyDetails.consecutiveNumber + '' : ''">
            </sc-read-only-field>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-read-only-field labelDictionaryKey="tmc-yard.secure-key.entity.hash-code"
              [value]="secureKeyDetails.hashCode != null ? secureKeyDetails.hashCode + '' : ''">
            </sc-read-only-field>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-string-field grow formControlName="usage" labelDictionaryKey="tmc-yard.secure-key.entity.usage">
            </sc-string-field>

            <sc-content-spacer vertical></sc-content-spacer>
            <mat-checkbox formControlName="active" name="active">
              <sc-dictionary-label dictionaryKey="tmc-yard.secure-key.entity.active"></sc-dictionary-label>
            </mat-checkbox>

            <sc-content-spacer vertical></sc-content-spacer>
            <sc-title>
              <sc-dictionary-label
                dictionaryKey="tmc-yard.ui.admin.secure-key-administration.area-gates.title"></sc-dictionary-label>
            </sc-title>
            <sc-content-spacer vertical></sc-content-spacer>

            <div class="area-gates">

              <sc-flex vertical stretchContent [gap]="16">
                <sc-row-container *ngFor="let areaGate of secureKeyDetails.areaGateAssignments | callback: filterAreaGateAssignments ">
                  <sc-padding>

                    <sc-flex>
                      <sc-read-only-field style="flex-grow: 1;"
                        labelDictionaryKey="tmc-yard.secure-key.entity.area-gate.name" [value]="areaGate.areaGateName">
                      </sc-read-only-field>
                      <sc-content-spacer [vertical]="false"></sc-content-spacer>
                      <div class="delete-button">
                        <sc-icon iconClass="fa-trash" (click)="removeAreaGateAssignment(areaGate)"></sc-icon>
                      </div>
                    </sc-flex>

                  </sc-padding>
                </sc-row-container>
              </sc-flex>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-action-icon (click)="addAreaGateAssignment()" iconClass="fa-plus fa-2x"></sc-action-icon>

            </div>

          </sc-flex>
        </sc-padding>
      </form>

    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>

</div>
